<template>
  <div>
    <v-card
        width="100%"
        class="mx-auto"
        flat
    >
      <v-toolbar
          color="primary"
          dark
          flat
      >
        <v-toolbar-title>Ferramentas</v-toolbar-title>
      </v-toolbar>

      <v-list
          dense
          flat
          class="pa-0"
      >
        <div v-if="cpGetDivisaoEmEdicao && cpGetDivisaoEmEdicao.componenteTipo == 'tabela-preco'">

          <div class="deep-purple lighten-5">
            <h4 class="ml-2 mt-0">
              Nome da tabela
            </h4>

            <v-list-item
                class="pl-4"
            >
              <v-list-item-content>
                <v-switch
                    v-model="cabecalhoExibir"
                    label="Exibir"
                    dense
                    class="pa-0 mt-1"
                    hide-details="true"
                ></v-switch>
              </v-list-item-content>
            </v-list-item>

            <div v-show="cabecalhoExibir">
              <v-list-item
                  class="pl-4"
              >
                <v-list-item-content>
                  <v-row class="no-gutter">
                    <v-col>
                      <v-select
                          label="Tamanho"
                          v-model="cabecalhoStyleFontSize"
                          :items="fontSizes"
                          item-value="value"
                          item-text="text"
                          dense
                          hide-details
                      ></v-select>
                    </v-col>
                  </v-row>

                </v-list-item-content>
              </v-list-item>

              <v-list-item
                  class="pl-4"
              >
                <v-row no-gutters>
                  <v-col>
                    <v-list-item-content align="start">
                      <v-list-item-title
                          class="ma-0 pa-0"
                      >
                        Fonte
                      </v-list-item-title>
                      <FontChooser v-model="cabecalhoStyleFontFamily"></FontChooser>
                    </v-list-item-content>
                  </v-col>
                  <v-col>
                    <v-list-item-content align="start">
                      <v-list-item-title
                          class="ma-0 pa-0"
                      >
                        Fundo
                      </v-list-item-title>
                      <v-row no-gutters dense>
                        <ImageGallery v-model="cabecalhoImg"></ImageGallery>
                        <v-icon class="pa-0 ma-0" style="cursor: pointer;" @click="cabecalhoImg=''">
                          mdi-close
                        </v-icon>
                      </v-row>
                    </v-list-item-content>
                  </v-col>
                </v-row>
              </v-list-item>

              <v-list-item
                  class="pl-4"
              >
                <v-list-item-content>
                  <v-list-item-title
                      class="ma-0 pa-0"
                  >
                    Alinhamento
                  </v-list-item-title>
                  <v-btn-toggle
                      v-model="cabecalhoTextoClassAlign"
                      mandatory
                  >
                    <v-btn
                        value="text-left"
                        small
                    >
                      <v-icon>mdi-format-align-left</v-icon>
                    </v-btn>
                    <v-btn
                        value="text-center"
                        small
                    >
                      <v-icon>mdi-format-align-center</v-icon>
                    </v-btn>
                    <v-btn
                        value="text-right"
                        small
                    >
                      <v-icon>mdi-format-align-right</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                  class="pl-4"
              >
                <v-list-item-content>
                  <v-list-item-title
                      class="ma-0 pa-0"
                  >
                    Estilo
                  </v-list-item-title>
                  <v-btn-toggle
                      v-model="cabecalhoTextoClassEstilo"
                      dense
                      multiple
                  >
                    <v-btn
                        value="font-weight-bold"
                        small
                    >
                      <v-icon>mdi-format-bold</v-icon>
                    </v-btn>

                    <v-btn
                        value="font-italic"
                        small
                    >
                      <v-icon>mdi-format-italic</v-icon>
                    </v-btn>

                    <v-btn
                        value="text-decoration-underline"
                        small
                    >
                      <v-icon>mdi-format-underline</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                  class="pl-4"
              >
                <v-list-item-content>

                  <v-row no-gutters>
                    <v-col>
                      <v-list-item-title
                          class="ma-0 pa-0"
                      >
                        Cor do texto
                      </v-list-item-title>
                      <ColorPicker
                          v-model="cabecalhoStyleColor"
                      ></ColorPicker>
                    </v-col>
                    <v-col>
                      <v-list-item-title
                          class="ma-0 pa-0"
                      >
                        Cor do fundo
                      </v-list-item-title>
                      <ColorPicker
                          v-model="cabecalhoStyleBackgroundColor"
                      ></ColorPicker>
                    </v-col>
                  </v-row>

                </v-list-item-content>
              </v-list-item>
            </div>
          </div>

          <!--configs thead-->
          <div class="deep-orange lighten-5">
            <h4 class="ml-2 mt-1">
              Cabeçalho (tabela)
            </h4>

            <v-list-item
                class="pl-4"
            >
              <v-list-item-content>
                <v-switch
                    v-model="tHeadExibir"
                    label="Exibir"
                    dense
                    class="pa-0 mt-1"
                    hide-details="true"
                ></v-switch>
              </v-list-item-content>
            </v-list-item>

            <div v-show="tHeadExibir">
              <v-list-item
                  class="pl-4"
              >
                <v-list-item-content>
                  <v-select
                      label="Tamanho"
                      v-model="tHeadStyleFontSize"
                      :items="fontSizes"
                      item-value="value"
                      item-text="text"
                      dense
                      hide-details
                  ></v-select>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                  class="pl-4"
              >
                <v-row no-gutters>
                  <v-col>
                    <v-list-item-content align="start">
                      <v-list-item-title
                          class="ma-0 pa-0"
                      >
                        Fonte
                      </v-list-item-title>
                      <FontChooser v-model="tHeadStyleFontFamily"></FontChooser>
                    </v-list-item-content>
                  </v-col>
                </v-row>
              </v-list-item>

              <v-list-item
                  class="pl-4"
              >
                <v-list-item-content>
                  <v-list-item-title
                      class="ma-0 pa-0"
                  >
                    Estilo
                  </v-list-item-title>
                  <v-btn-toggle
                      v-model="tHeadTextoClassEstilo"
                      dense
                      multiple
                  >
                    <!--                  <v-btn-->
                    <!--                      value="font-weight-bold"-->
                    <!--                      small-->
                    <!--                  >-->
                    <!--                    <v-icon>mdi-format-bold</v-icon>-->
                    <!--                  </v-btn>-->

                    <v-btn
                        value="font-italic"
                        small
                    >
                      <v-icon>mdi-format-italic</v-icon>
                    </v-btn>

                    <v-btn
                        value="text-decoration-underline"
                        small
                    >
                      <v-icon>mdi-format-underline</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                  class="pl-4"
              >
                <v-list-item-content>

                  <v-row no-gutters>
                    <v-col>
                      <v-list-item-title
                          class="ma-0 pa-0"
                      >
                        Cor do texto
                      </v-list-item-title>
                      <ColorPicker
                          v-model="tHeadStyleColor"
                      ></ColorPicker>
                    </v-col>
                    <v-col>
                      <v-list-item-title
                          class="ma-0 pa-0"
                      >
                        Cor do fundo
                      </v-list-item-title>
                      <ColorPicker
                          v-model="tHeadStyleBackgroundColor"
                      ></ColorPicker>
                    </v-col>
                  </v-row>

                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
          <!--fim configs thead-->

          <div class="blue lighten-5">
            <h4 class="ml-2 mt-1">
              Produtos
            </h4>

            <v-list-item
                class="pl-4"
            >
              <v-list-item-content>
                <v-select
                    label="Tamanho"
                    v-model="tBodyStyleFontSize"
                    :items="fontSizes"
                    item-value="value"
                    item-text="text"
                    dense
                    hide-details
                ></v-select>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
                class="pl-4"
            >
              <v-row no-gutters>
                <v-col>
                  <v-list-item-content align="start">
                    <v-list-item-title
                        class="ma-0 pa-0"
                    >
                      Fonte
                    </v-list-item-title>
                    <FontChooser v-model="tBodyStyleFontFamily"></FontChooser>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </v-list-item>

            <v-list-item
                class="pl-4"
            >
              <v-list-item-content>
                <v-list-item-title
                    class="ma-0 pa-0"
                >
                  Estilo
                </v-list-item-title>
                <v-btn-toggle
                    v-model="tBodyTextoClassEstilo"
                    dense
                    multiple
                >
                  <v-btn
                      value="font-weight-bold"
                      small
                  >
                    <v-icon>mdi-format-bold</v-icon>
                  </v-btn>

                  <v-btn
                      value="font-italic"
                      small
                  >
                    <v-icon>mdi-format-italic</v-icon>
                  </v-btn>

                  <v-btn
                      value="text-decoration-underline"
                      small
                  >
                    <v-icon>mdi-format-underline</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
                class="pl-4"
            >
              <v-list-item-content>

                <v-row no-gutters>
                  <v-col>
                    <v-list-item-title
                        class="ma-0 pa-0"
                    >
                      Cor do texto
                    </v-list-item-title>
                    <ColorPicker
                        v-model="tBodyStyleColor"
                    ></ColorPicker>
                  </v-col>
                  <v-col>
                    <v-list-item-title
                        class="ma-0 pa-0"
                    >
                      Cor do fundo
                    </v-list-item-title>
                    <ColorPicker
                        v-model="tBodyStyleBackgroundColor"
                    ></ColorPicker>
                  </v-col>
                </v-row>

              </v-list-item-content>
            </v-list-item>

          </div>

          <v-divider></v-divider>

          <div class="blue lighten-5">
            <h4 class="ml-2 mt-1">
              Destaques
            </h4>
            <v-list-item
                class="pl-4"
            >
              <v-list-item-content>
                <v-switch
                    v-model="destaqueExibir"
                    label="Exibir destaques"
                    dense
                    class="pa-0 mt-1"
                    hide-details="true"
                ></v-switch>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
                class="pl-4"
            >
              <v-list-item-content>
                <v-text-field
                    v-model="destaqueTexto"
                    class="pb-0 mb-0"
                    hide-details
                    label="Texto"
                    placeholder="Ex. Oferta!"
                    dense
                    outlined
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
                class="pl-4"
            >
              <v-list-item-content>
                <v-menu
                    bottom
                    origin="center center"
                    transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-row class="mx-auto">
                      <v-col>
                        <v-btn
                            small
                            v-bind="attrs"
                            v-on="on"
                        >
                          Icone
                          <v-icon v-if="destaqueIcone.length > 0" right>
                            {{ destaqueIcone }}
                          </v-icon>
                        </v-btn>

                      </v-col>
                      <v-col>
                        <v-icon class="pa-0 ma-0" style="cursor: pointer;"
                                @click="destaqueIcone=''">
                          mdi-close
                        </v-icon>
                      </v-col>
                    </v-row>
                  </template>

                  <v-card
                      max-width="16rem"
                  >
                    <v-card-text>
                      <v-row>
                        <v-col
                            v-for="(icone, i) in iconesDisponiveis"
                            :key="i"
                            dense
                            style="cursor: pointer;"
                            @click="destaqueIcone = icone"
                        >
                          <v-icon>{{ icone }}</v-icon>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-menu>

              </v-list-item-content>
            </v-list-item>

            <v-list-item
                class="pl-4"
            >
              <v-list-item-content class="py-1">
                <v-list-item-title
                    class="ma-0 pa-0"
                >
                  Posição do icone
                </v-list-item-title>
                <v-radio-group
                    v-model="destaqueIconePosition"
                    row
                    dense
                    class="pa-0 ma-0"
                    hide-details
                >
                  <v-radio label="Inicio" value="left"></v-radio>
                  <v-radio label="Fim" value="right"></v-radio>
                </v-radio-group>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
                class="pl-4"
            >
              <v-list-item-content>
                <v-list-item-title
                    class="ma-0 pa-0"
                >
                  Cor do texto/icone
                </v-list-item-title>
                <ColorPicker
                    v-model="destaqueStyleColor"
                ></ColorPicker>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
                class="pl-4"
            >
              <v-list-item-content>
                <v-list-item-title
                    class="ma-0 pa-0"
                >
                  Cor do fundo
                </v-list-item-title>
                <ColorPicker
                    v-model="destaqueStyleBackgroundColor"
                ></ColorPicker>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
                class="pl-4"
            >
              <v-list-item-content>
                <v-switch
                    v-model="destaqueRounded"
                    label="Arredondar contorno"
                    dense
                    class="pa-0 mt-1"
                    hide-details="true"
                ></v-switch>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
                class="pl-4"
            >
              <v-list-item-content>
                <v-switch
                    v-model="destaqueOutlined"
                    label="Apenas contorno"
                    dense
                    class="pa-0 mt-1"
                    hide-details="true"
                ></v-switch>
              </v-list-item-content>
            </v-list-item>
          </div>
        </div>

        <div v-if="cpGetDivisaoEmEdicao && cpGetDivisaoEmEdicao.componenteTipo == 'cartaz'">
          <!--CARTAZ-->
          <!--<editor-fold desc="confgs meio">-->
          <div class="blue lighten-5">
            <!--            <v-list-item-->
            <!--                class="pl-4"-->
            <!--            >-->
            <!--              <v-list-item-content>-->
            <!--                <v-list-item-title-->
            <!--                    class="ma-0 pa-0"-->
            <!--                >-->
            <!--                  Cor do fundo-->
            <!--                </v-list-item-title>-->
            <!--                <ColorPicker-->
            <!--                    v-model="meioStyleBackgroundColor"-->
            <!--                ></ColorPicker>-->
            <!--              </v-list-item-content>-->
            <!--            </v-list-item>-->

            <v-list-item
                class="pl-4"
            >
              <v-list-item-content>
                <v-list-item-title
                    class="ma-0 pa-0"
                >
                </v-list-item-title>
                <v-row no-gutters>
                  <v-col>
                    <SelecionaElemento
                        :tipo="'mercadoria'"
                        v-on:emitItem="addCartazMeioElementoMercadoria"
                    >
                      <template v-slot:default="{open}">
                        <v-btn
                            fab
                            depressed
                            outlined
                            color="primary"
                            small
                            title="Add mercadoria do cadastro"
                            @click="open"
                        >
                          <v-icon>mdi-cart-plus</v-icon>
                        </v-btn>
                      </template>
                    </SelecionaElemento>
                  </v-col>
                  <v-col>
                    <SelecionaElemento
                        :tipo="'tabela-preco'"
                        v-on:emitItem="addCartazMeioElementoTabelaPreco"
                    >
                      <template v-slot:default="{open}">
                        <v-btn
                            fab
                            depressed
                            outlined
                            color="primary"
                            small
                            title="Add tabela de preços"
                            @click="open"
                        >
                          <v-icon>mdi-table-plus</v-icon>
                        </v-btn>
                      </template>
                    </SelecionaElemento>
                  </v-col>
                  <v-col>
                    <v-btn
                        fab
                        depressed
                        outlined
                        color="primary"
                        small
                        title="Add texto livre"
                        @click="addCartazMeioElementoTexto({tipo: 'texto'})"
                    >
                      <v-icon>mdi-format-annotation-plus</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col>
                    <ImageGallery v-on:input="addCartazMeioElementoImagem">
                      <template v-slot:default="{open}">
                        <v-btn
                            fab
                            depressed
                            outlined
                            color="primary"
                            small
                            title="Add imagem/video"
                            @click="open"
                        >
                          <v-icon>mdi-image-plus</v-icon>
                        </v-btn>
                      </template>
                    </ImageGallery>
                  </v-col>

<!--                  @todo-later comentando o btn de add link, precisa melhorar isso (ver comment do commit)-->
<!--                  <v-col>-->
<!--                    <v-btn-->
<!--                        fab-->
<!--                        depressed-->
<!--                        outlined-->
<!--                        color="primary"-->
<!--                        small-->
<!--                        title="Add link"-->
<!--                        @click="addCartazMeioElementoTexto({tipo: 'link'})"-->
<!--                    >-->
<!--                      <v-icon>mdi-link-plus</v-icon>-->
<!--                    </v-btn>-->
<!--                  </v-col>-->
                </v-row>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
                class="pa-0"
            >
              <v-list-item-content

              >
                <v-expansion-panels flat accordion focusable>
                  <v-expansion-panel
                      v-for="(elemento, i) in this.$store.getters.getMeioElementosDaDivisao"
                      :key="i"
                  >
                    <v-expansion-panel-header
                        color="blue lighten-5"
                        style="border-top: #abaca7 1px solid !important;"
                    >
                      <template v-slot:default="{ open }">
                        <v-row no-gutters>
                          <v-col
                              cols="8"
                              class="text--secondary"
                          >
                            <v-icon dense color="blue" v-if="elemento.tipo == 'mercadoria'">
                              mdi-cart-outline
                            </v-icon>
                            <v-icon dense color="blue" v-if="elemento.tipo == 'tabela-preco'">
                              mdi-table
                            </v-icon>
                            <v-icon dense color="blue" v-if="elemento.tipo == 'texto'">
                              mdi-format-text-variant
                            </v-icon>
                            <v-icon dense color="blue" v-if="elemento.tipo == 'imagem'">
                              mdi-image
                            </v-icon>
                            <v-icon dense color="blue" v-if="elemento.tipo == 'link'">
                              mdi-link
                            </v-icon>

                            <v-fade-transition leave-absolute>
                              <span v-if="elemento.tipo == 'mercadoria'">
                                {{ elemento.mercDataAux.codigo }} -
                                {{ elemento.mercDataAux.descricao }}
                              </span>

                              <span v-if="elemento.tipo == 'tabela-preco'">
                                {{ elemento.tabelaPrecoDataAux.nome }}
                              </span>

                              <span v-if="elemento.tipo == 'texto'">
                                {{!elemento.conteudo.toString().length ? 'texto livre' : elemento.conteudo.toString()}}
                              </span>

                              <span v-if="elemento.tipo == 'imagem'">
                                <span v-if="elemento.nomeOriginal">{{elemento.nomeOriginal}}</span>
                                <span v-else>{{elemento.conteudo}}</span>
                              </span>

                              <span v-if="elemento.tipo == 'link'">
                                {{!elemento.conteudo.toString().length ? 'link' : elemento.conteudo.toString()}}
                              </span>

                            </v-fade-transition>
                          </v-col>
                        </v-row>
                      </template>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content
                        color="blue lighten-5"
                    >

                      <v-row no-gutters>
                        <v-col align="right">
                          <v-btn
                              @click="rmCartazMeioElemento(i)"
                              icon
                              small
                              title="remover elemento"
                          >
                            <v-icon color="red">mdi-delete</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                              v-model="elemento.draggable.zIndex"
                              type="number"
                              min="0"
                              @focus="setMeioElementoEmEdicaoIndex(i)"
                              label="Sobreposição"
                              placeholder="Sobreposição"
                              hide-details
                              dense
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row v-if="elemento.tipo == 'link'">
                        <v-col>
                          <v-text-field
                              v-model="elemento.conteudo"
                              @focus="setMeioElementoEmEdicaoIndex(i)"
                              label="Link"
                              placeholder="http://..."
                              hide-details
                              dense
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <div v-if="elemento.tipo == 'texto' || elemento.tipo == 'mercadoria'">

                        <v-row v-if="elemento.tipo == 'texto'">
                          <v-col>
                            <v-text-field
                                v-model="elemento.conteudo"
                                @focus="setMeioElementoEmEdicaoIndex(i)"
                                label="Texto livre"
                                placeholder="texto livre"
                                hide-details
                                dense
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <div v-if="elemento.tipo == 'mercadoria'">
                          <v-row no-gutters>
                            <v-col>
                              <v-switch
                                  v-model="elemento.mercOptions.exibirCodigo"
                                  @focus="setMeioElementoEmEdicaoIndex(i)"
                                  label="Exibir cód."
                                  dense
                                  class="pa-0 mt-1"
                                  hide-details="true"
                              ></v-switch>
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col>
                              <v-switch
                                  v-model="elemento.mercOptions.exibirPreco"
                                  @focus="setMeioElementoEmEdicaoIndex(i)"
                                  label="Exibir preço"
                                  dense
                                  class="pa-0 mt-1"
                                  hide-details="true"
                              ></v-switch>
                            </v-col>
                          </v-row>
                        </div>

                        <v-row>
                          <v-col
                              @click="setMeioElementoEmEdicaoIndex(i)"
                          >
                            <v-list-item-title
                                class="ma-0 pa-0"
                            >
                              Fonte
                            </v-list-item-title>
                            <FontChooser v-model="elemento.style.fontFamily"></FontChooser>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col
                              @click="setMeioElementoEmEdicaoIndex(i)"
                          >
                            <v-list-item-title
                                class="ma-0 pa-0"
                            >
                              Estilo
                            </v-list-item-title>
                            <v-btn-toggle
                                v-model="elemento.class.estilo"
                                dense
                                multiple
                            >
                              <v-btn
                                  value="font-weight-bold"
                                  small
                              >
                                <v-icon>mdi-format-bold</v-icon>
                              </v-btn>

                              <v-btn
                                  value="font-italic"
                                  small
                              >
                                <v-icon>mdi-format-italic</v-icon>
                              </v-btn>

                              <v-btn
                                  value="text-decoration-underline"
                                  small
                              >
                                <v-icon>mdi-format-underline</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </v-col>
                        </v-row>

                        <v-row no-gutters @click="setMeioElementoEmEdicaoIndex(i)">
                          <v-col>
                            <v-list-item-title
                                class="ma-0 pa-0"
                            >
                              Cor do texto
                            </v-list-item-title>
                            <ColorPicker
                                v-model="elemento.style.color"
                            ></ColorPicker>
                          </v-col>
                          <v-col>
                            <v-list-item-title
                                class="ma-0 pa-0"
                            >
                              Cor do fundo
                            </v-list-item-title>
                            <ColorPicker
                                v-model="elemento.style['background-color']"
                            ></ColorPicker>
                          </v-col>
                        </v-row>
                      </div>

                      <div v-if="elemento.tipo == 'tabela-preco'">

                        <v-row>
                          <v-col>
                            <v-list-item-title
                                class="ma-0 pa-0"
                            >
                              Cor do fundo da tabela
                            </v-list-item-title>
                            <ColorPicker
                                v-model="elemento.tabelaPrecoOptions.tabelaStyle.backgroundColor"
                            ></ColorPicker>
                          </v-col>
                        </v-row>

                        <div class="deep-purple lighten-5">
                          <h4 class="ml-2 mt-0">
                            Nome da tabela
                          </h4>

                          <v-list-item
                              class="pl-4"
                          >
                            <v-list-item-content>
                              <v-switch
                                  v-model="elemento.tabelaPrecoOptions.cabecalhoExibir"
                                  label="Exibir"
                                  dense
                                  class="pa-0 mt-1"
                                  hide-details="true"
                              ></v-switch>
                            </v-list-item-content>
                          </v-list-item>

                          <div v-show="elemento.tabelaPrecoOptions.cabecalhoExibir">
                            <v-list-item
                                class="pl-4"
                            >
                              <v-list-item-content>
                                <v-row class="no-gutter">
                                  <v-col>
                                    <v-select
                                        label="Tamanho"
                                        v-model="elemento.tabelaPrecoOptions.cabecalhoStyle.fontSize"
                                        :items="fontSizes"
                                        item-value="value"
                                        item-text="text"
                                        dense
                                        hide-details
                                    ></v-select>
                                  </v-col>
                                </v-row>

                              </v-list-item-content>
                            </v-list-item>

                            <v-list-item
                                class="pl-4"
                            >
                              <v-row no-gutters>
                                <v-col>
                                  <v-list-item-content align="start">
                                    <v-list-item-title
                                        class="ma-0 pa-0"
                                    >
                                      Fonte
                                    </v-list-item-title>
                                    <FontChooser v-model="elemento.tabelaPrecoOptions.cabecalhoStyle.fontFamily"></FontChooser>
                                  </v-list-item-content>
                                </v-col>
                              </v-row>
                            </v-list-item>

                            <v-list-item
                                class="pl-4"
                            >
                              <v-list-item-content>
                                <v-list-item-title
                                    class="ma-0 pa-0"
                                >
                                  Alinhamento
                                </v-list-item-title>
                                <v-btn-toggle
                                    v-model="elemento.tabelaPrecoOptions.cabecalhoTextoClass.align"
                                    mandatory
                                >
                                  <v-btn
                                      value="text-left"
                                      small
                                  >
                                    <v-icon>mdi-format-align-left</v-icon>
                                  </v-btn>
                                  <v-btn
                                      value="text-center"
                                      small
                                  >
                                    <v-icon>mdi-format-align-center</v-icon>
                                  </v-btn>
                                  <v-btn
                                      value="text-right"
                                      small
                                  >
                                    <v-icon>mdi-format-align-right</v-icon>
                                  </v-btn>
                                </v-btn-toggle>
                              </v-list-item-content>
                            </v-list-item>

                            <v-list-item
                                class="pl-4"
                            >
                              <v-list-item-content>
                                <v-list-item-title
                                    class="ma-0 pa-0"
                                >
                                  Estilo
                                </v-list-item-title>
                                <v-btn-toggle
                                    v-model="elemento.tabelaPrecoOptions.cabecalhoTextoClass.estilo"
                                    dense
                                    multiple
                                >
                                  <v-btn
                                      value="font-weight-bold"
                                      small
                                  >
                                    <v-icon>mdi-format-bold</v-icon>
                                  </v-btn>

                                  <v-btn
                                      value="font-italic"
                                      small
                                  >
                                    <v-icon>mdi-format-italic</v-icon>
                                  </v-btn>

                                  <v-btn
                                      value="text-decoration-underline"
                                      small
                                  >
                                    <v-icon>mdi-format-underline</v-icon>
                                  </v-btn>
                                </v-btn-toggle>
                              </v-list-item-content>
                            </v-list-item>

                            <v-list-item
                                class="pl-4"
                            >
                              <v-list-item-content>

                                <v-row no-gutters>
                                  <v-col>
                                    <v-list-item-title
                                        class="ma-0 pa-0"
                                    >
                                      Cor do texto
                                    </v-list-item-title>
                                    <ColorPicker
                                        v-model="elemento.tabelaPrecoOptions.cabecalhoStyleColor"
                                    ></ColorPicker>
                                  </v-col>
                                  <v-col>
                                    <v-list-item-title
                                        class="ma-0 pa-0"
                                    >
                                      Cor do fundo
                                    </v-list-item-title>
                                    <ColorPicker
                                        v-model="elemento.tabelaPrecoOptions.cabecalhoStyle.backgroundColor"
                                    ></ColorPicker>
                                  </v-col>
                                </v-row>

                              </v-list-item-content>
                            </v-list-item>
                          </div>
                        </div>

                        <!--configs thead-->
                        <div class="deep-orange lighten-5">
                          <h4 class="ml-2 mt-1">
                            Cabeçalho (tabela)
                          </h4>

                          <v-list-item
                              class="pl-4"
                          >
                            <v-list-item-content>
                              <v-switch
                                  v-model="elemento.tabelaPrecoOptions.tHeadExibir"
                                  label="Exibir"
                                  dense
                                  class="pa-0 mt-1"
                                  hide-details="true"
                              ></v-switch>
                            </v-list-item-content>
                          </v-list-item>

                          <div v-show="elemento.tabelaPrecoOptions.tHeadExibir">
                            <v-list-item
                                class="pl-4"
                            >
                              <v-list-item-content>
                                <v-select
                                    label="Tamanho"
                                    v-model="elemento.tabelaPrecoOptions.tHeadStyle.fontSize"
                                    :items="fontSizes"
                                    item-value="value"
                                    item-text="text"
                                    dense
                                    hide-details
                                ></v-select>
                              </v-list-item-content>
                            </v-list-item>

                            <v-list-item
                                class="pl-4"
                            >
                              <v-row no-gutters>
                                <v-col>
                                  <v-list-item-content align="start">
                                    <v-list-item-title
                                        class="ma-0 pa-0"
                                    >
                                      Fonte
                                    </v-list-item-title>
                                    <FontChooser v-model="elemento.tabelaPrecoOptions.tHeadStyle.fontFamily"></FontChooser>
                                  </v-list-item-content>
                                </v-col>
                              </v-row>
                            </v-list-item>

                            <v-list-item
                                class="pl-4"
                            >
                              <v-list-item-content>
                                <v-list-item-title
                                    class="ma-0 pa-0"
                                >
                                  Estilo
                                </v-list-item-title>
                                <v-btn-toggle
                                    v-model="elemento.tabelaPrecoOptions.tHeadTextoClass.estilo"
                                    dense
                                    multiple
                                >
                                  <!--                  <v-btn-->
                                  <!--                      value="font-weight-bold"-->
                                  <!--                      small-->
                                  <!--                  >-->
                                  <!--                    <v-icon>mdi-format-bold</v-icon>-->
                                  <!--                  </v-btn>-->

                                  <v-btn
                                      value="font-italic"
                                      small
                                  >
                                    <v-icon>mdi-format-italic</v-icon>
                                  </v-btn>

                                  <v-btn
                                      value="text-decoration-underline"
                                      small
                                  >
                                    <v-icon>mdi-format-underline</v-icon>
                                  </v-btn>
                                </v-btn-toggle>
                              </v-list-item-content>
                            </v-list-item>

                            <v-list-item
                                class="pl-4"
                            >
                              <v-list-item-content>

                                <v-row no-gutters>
                                  <v-col>
                                    <v-list-item-title
                                        class="ma-0 pa-0"
                                    >
                                      Cor do texto
                                    </v-list-item-title>
                                    <ColorPicker
                                        v-model="elemento.tabelaPrecoOptions.tHeadStyle.color"
                                    ></ColorPicker>
                                  </v-col>
                                  <v-col>
                                    <v-list-item-title
                                        class="ma-0 pa-0"
                                    >
                                      Cor do fundo
                                    </v-list-item-title>
                                    <ColorPicker
                                        v-model="elemento.tabelaPrecoOptions.tHeadStyle.backgroundColor"
                                    ></ColorPicker>
                                  </v-col>
                                </v-row>

                              </v-list-item-content>
                            </v-list-item>
                          </div>
                        </div>
                        <!--fim configs thead-->

                        <div class="blue lighten-5">
                          <h4 class="ml-2 mt-1">
                            Produtos
                          </h4>

                          <v-list-item
                              class="pl-4"
                          >
                            <v-list-item-content>
                              <v-select
                                  label="Tamanho"
                                  v-model="elemento.tabelaPrecoOptions.tBodyStyle.fontSize"
                                  :items="fontSizes"
                                  item-value="value"
                                  item-text="text"
                                  dense
                                  hide-details
                              ></v-select>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item
                              class="pl-4"
                          >
                            <v-row no-gutters>
                              <v-col>
                                <v-list-item-content align="start">
                                  <v-list-item-title
                                      class="ma-0 pa-0"
                                  >
                                    Fonte
                                  </v-list-item-title>
                                  <FontChooser v-model="elemento.tabelaPrecoOptions.tBodyStyle.fontFamily"></FontChooser>
                                </v-list-item-content>
                              </v-col>
                            </v-row>
                          </v-list-item>

                          <v-list-item
                              class="pl-4"
                          >
                            <v-list-item-content>
                              <v-list-item-title
                                  class="ma-0 pa-0"
                              >
                                Estilo
                              </v-list-item-title>
                              <v-btn-toggle
                                  v-model="elemento.tabelaPrecoOptions.tBodyTextoClass.estilo"
                                  dense
                                  multiple
                              >
                                <v-btn
                                    value="font-weight-bold"
                                    small
                                >
                                  <v-icon>mdi-format-bold</v-icon>
                                </v-btn>

                                <v-btn
                                    value="font-italic"
                                    small
                                >
                                  <v-icon>mdi-format-italic</v-icon>
                                </v-btn>

                                <v-btn
                                    value="text-decoration-underline"
                                    small
                                >
                                  <v-icon>mdi-format-underline</v-icon>
                                </v-btn>
                              </v-btn-toggle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item
                              class="pl-4"
                          >
                            <v-list-item-content>

                              <v-row no-gutters>
                                <v-col>
                                  <v-list-item-title
                                      class="ma-0 pa-0"
                                  >
                                    Cor do texto
                                  </v-list-item-title>
                                  <ColorPicker
                                      v-model="elemento.tabelaPrecoOptions.tBodyStyle.color"
                                  ></ColorPicker>
                                </v-col>
                                <v-col>
                                  <v-list-item-title
                                      class="ma-0 pa-0"
                                  >
                                    Cor do fundo
                                  </v-list-item-title>
                                  <ColorPicker
                                      v-model="elemento.tabelaPrecoOptions.tBodyStyle.backgroundColor"
                                  ></ColorPicker>
                                </v-col>
                              </v-row>

                            </v-list-item-content>
                          </v-list-item>

                        </div>

                        <v-divider></v-divider>

                        <div class="blue lighten-5">
                          <h4 class="ml-2 mt-1">
                            Destaques
                          </h4>
                          <v-list-item
                              class="pl-4"
                          >
                            <v-list-item-content>
                              <v-switch
                                  v-model="elemento.tabelaPrecoOptions.destaqueExibir"
                                  label="Exibir destaques"
                                  dense
                                  class="pa-0 mt-1"
                                  hide-details="true"
                              ></v-switch>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item
                              class="pl-4"
                          >
                            <v-list-item-content>
                              <v-text-field
                                  v-model="elemento.tabelaPrecoOptions.destaqueTexto"
                                  class="pb-0 mb-0"
                                  hide-details
                                  label="Texto"
                                  placeholder="Ex. Oferta!"
                                  dense
                                  outlined
                              ></v-text-field>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item
                              class="pl-4"
                          >
                            <v-list-item-content>
                              <v-menu
                                  bottom
                                  origin="center center"
                                  transition="scale-transition"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-row class="mx-auto">
                                    <v-col>
                                      <v-btn
                                          small
                                          v-bind="attrs"
                                          v-on="on"
                                      >
                                        Icone
                                        <v-icon v-if="elemento.tabelaPrecoOptions.destaqueIcone.length > 0" right>
                                          {{ elemento.tabelaPrecoOptions.destaqueIcone }}
                                        </v-icon>
                                      </v-btn>

                                    </v-col>
                                    <v-col>
                                      <v-icon class="pa-0 ma-0" style="cursor: pointer;"
                                              @click="elemento.tabelaPrecoOptions.destaqueIcone=''">
                                        mdi-close
                                      </v-icon>
                                    </v-col>
                                  </v-row>
                                </template>

                                <v-card
                                    max-width="16rem"
                                >
                                  <v-card-text>
                                    <v-row>
                                      <v-col
                                          v-for="(icone, i) in iconesDisponiveis"
                                          :key="i"
                                          dense
                                          style="cursor: pointer;"
                                          @click="elemento.tabelaPrecoOptions.destaqueIcone = icone"
                                      >
                                        <v-icon>{{ icone }}</v-icon>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                              </v-menu>

                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item
                              class="pl-4"
                          >
                            <v-list-item-content class="py-1">
                              <v-list-item-title
                                  class="ma-0 pa-0"
                              >
                                Posição do icone
                              </v-list-item-title>
                              <v-radio-group
                                  v-model="elemento.tabelaPrecoOptions.destaqueIconePosition"
                                  row
                                  dense
                                  class="pa-0 ma-0"
                                  hide-details
                              >
                                <v-radio label="Inicio" value="left"></v-radio>
                                <v-radio label="Fim" value="right"></v-radio>
                              </v-radio-group>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item
                              class="pl-4"
                          >
                            <v-list-item-content>
                              <v-list-item-title
                                  class="ma-0 pa-0"
                              >
                                Cor do texto/icone
                              </v-list-item-title>
                              <ColorPicker
                                  v-model="elemento.tabelaPrecoOptions.destaqueStyle.color"
                              ></ColorPicker>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item
                              class="pl-4"
                          >
                            <v-list-item-content>
                              <v-list-item-title
                                  class="ma-0 pa-0"
                              >
                                Cor do fundo
                              </v-list-item-title>
                              <ColorPicker
                                  v-model="elemento.tabelaPrecoOptions.destaqueStyle.backgroundColor"
                              ></ColorPicker>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item
                              class="pl-4"
                          >
                            <v-list-item-content>
                              <v-switch
                                  v-model="elemento.tabelaPrecoOptions.destaqueRounded"
                                  label="Arredondar contorno"
                                  dense
                                  class="pa-0 mt-1"
                                  hide-details="true"
                              ></v-switch>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item
                              class="pl-4"
                          >
                            <v-list-item-content>
                              <v-switch
                                  v-model="elemento.tabelaPrecoOptions.destaqueOutlined"
                                  label="Apenas contorno"
                                  dense
                                  class="pa-0 mt-1"
                                  hide-details="true"
                              ></v-switch>
                            </v-list-item-content>
                          </v-list-item>
                        </div>
                      </div>

                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

              </v-list-item-content>
              <!--              <v-row justify="center">-->
              <!--              </v-row>-->
            </v-list-item>
          </div>
          <!--</editor-fold> confgs meio-->
        </div>

      </v-list>

      <v-card-text
          v-if="!cpGetDivisaoEmEdicao || cpGetDivisaoEmEdicao.componenteTipo.length == 0"
          class="justify-center align-center pt-16"
      >
        As ferramentas são exibidas de acordo com o componente em edição
      </v-card-text>

    </v-card>

    <v-dialog
        v-model="buscaMercadoriaDialog"
        width="60%"
    >
      <v-card
          class="mt-1 mr-1"
          outlined
          elevation="2"
      >
        <v-card-title class="pb-0">
          Mercadorias do cadastro
        </v-card-title>

        <v-card-text>
          <Mercadoria
              v-on:emitItem="addCartazMeioElementoMercadoria"
              is-used-into-another-view="timeline-modal-busca-mercadoria"
          ></Mercadoria>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="primary darken-1"
              text
              @click="buscaMercadoriaDialog = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import {timelineMixin} from "../timelineMixin";
import ColorPicker from "../../../components/ColorPicker";
import FontChooser from "../../../components/FontChooser";
import ImageGallery from "../../../components/ImageGallery";
import Mercadoria from "../../Mercadoria";
import SelecionaElemento from "@/views/timeline/components/SelecionaElemento";

export default {
  name: "Ferramentas",
  components: {SelecionaElemento, Mercadoria, ImageGallery, FontChooser, ColorPicker},
  mixins: [timelineMixin],

  data() {
    return {
      fontSizes: [
        {"value": '2', "text": '4'},
        {"value": '2.5', "text": '6'},
        {"value": '3', "text": '8'},
        {"value": '3.5', "text": '10'},
        {"value": '4', "text": '12'},
        {"value": '4.5', "text": '14'},
        {"value": '5', "text": '16'},
        {"value": '5.5', "text": '18'},
        {"value": '6', "text": '20'},
        {"value": '6.5', "text": '22'},
        {"value": '7', "text": '24'},
        {"value": '7.5', "text": '26'},
        {"value": '8', "text": '28'},
        {"value": '8.5', "text": '30'},
        {"value": '9', "text": '32'},
        {"value": '9.5', "text": '34'},
        {"value": '10', "text": '36'},
        {"value": '10.5', "text": '38'},
        {"value": '11', "text": '40'},
        {"value": '11.5', "text": '42'},
        {"value": '12', "text": '44'},
        {"value": '12.5', "text": '46'},
        {"value": '13', "text": '48'},
        {"value": '13.5', "text": '50'},
        {"value": '14', "text": '52'},
        {"value": '14.5', "text": '54'},
        {"value": '15', "text": '56'},
        {"value": '15.5', "text": '58'},
        {"value": '16', "text": '60'},
      ],

      aTextTitleSizes: [
        {"value": "text-h1", "text": "Heading 1"},
        {"value": "text-h2", "text": "Heading 2"},
        {"value": "text-h3", "text": "Heading 3"},
        {"value": "text-h4", "text": "Heading 4"},
        {"value": "text-h5", "text": "Heading 5"},
        {"value": "text-h6", "text": "Heading 6"},
        {"value": "text-subtitle-1", "text": "Subtitle 1"},
        {"value": "text-subtitle-2", "text": "Subtitle 2"},

        {"value": "text-body-1", "text": "Body 1"},
        {"value": "text-body-2", "text": "Body 2"},

        {"value": "caption", "text": "Caption"},
        {"value": "overline", "text": "Overline"},

        {"value": "", "text": "Normal"},
      ],
      iconesDisponiveis: [
        "mdi-star",
        "mdi-star-box",
        "mdi-tag",
        "mdi-tag-outline",
        "mdi-tag-off",
        "mdi-tag-off-outline",
        "mdi-tag-text",
        "mdi-tag-text-outline",
        "mdi-tag-minus",
        "mdi-tag-minus-outline",
        "mdi-tag-faces",
        "mdi-alert-decagram",
        "mdi-check-decagram",
        "mdi-decagram",
        "mdi-decagram-outline",
        "mdi-currency-usd-off",
        "mdi-thumb-up",
        "mdi-thumb-up-outline",
        "mdi-svg",
        "mdi-sheep",
        "mdi-cow",
        "mdi-fish",
        "mdi-jellyfish",
        "mdi-jellyfish-outline",
        "mdi-pig",
        "mdi-pig-variant",
        "mdi-food-drumstick",
        "mdi-food-drumstick-outline",
        "mdi-medal",
        "mdi-medal-outline",
        "mdi-hand-pointing-left",
        "mdi-hand-pointing-right",
        "mdi-fruit-cherries",
        "mdi-fruit-grapes",
        "mdi-fruit-grapes-outline",
        "mdi-fruit-pineapple",
        "mdi-fruit-watermelon",
      ],

      buscaMercadoriaDialog: false,
    }
  },

  computed: {
    divisaoTelaCheia: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.divisaoTelaCheia;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.divisaoTelaCheia = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    divisaoStyleBackgroundColor: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg && cfg.divisaoStyle) {
          return cfg.divisaoStyle["background-color"];
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.divisaoStyle["background-color"] = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    // region tabela
    cabecalhoExibir: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.cabecalhoExibir;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.cabecalhoExibir = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },
    // as outras configs de cabecalho sao as mesmas do cartaz, usando os mesmos metodos

    tHeadExibir: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.tHeadExibir;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.tHeadExibir = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    // tHeadTextoClassSize: {
    //   get() {
    //     let cfg = this.getDivisaoEmEdicaoConfigs();
    //
    //     if (cfg) {
    //       return cfg.tHeadTextoClass.size;
    //     }
    //
    //     return null;
    //   },
    //   set(v) {
    //     let cfg = this.getDivisaoEmEdicaoConfigs();
    //     cfg.tHeadTextoClass.size = v;
    //     this.$store.commit('setDivisaoConfigs', cfg);
    //   }
    // },

    tHeadTextoClassAlign: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.tHeadTextoClass.align;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.tHeadTextoClass.align = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    tHeadTextoClassEstilo: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.tHeadTextoClass.estilo;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.tHeadTextoClass.estilo = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    tHeadTextoClassWeight: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.tHeadTextoClass.weight;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.tHeadTextoClass.weight = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    tHeadTextoClassItalic: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.tHeadTextoClass.italic;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.tHeadTextoClass.italic = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    tHeadStyleFontFamily: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.tHeadStyle.fontFamily;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.tHeadStyle.fontFamily = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    tHeadStyleColor: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.tHeadStyle.color;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.tHeadStyle.color = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    tHeadStyleFontSize: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.tHeadStyle.fontSize;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.tHeadStyle.fontSize = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    tHeadImg: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.tHeadImg;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.tHeadImg = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    tHeadStyleBackgroundColor: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.tHeadStyle["background-color"];
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.tHeadStyle["background-color"] = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    //tbody
    // tBodyTextoClassSize: {
    //   get() {
    //     let cfg = this.getDivisaoEmEdicaoConfigs();
    //
    //     if (cfg) {
    //       return cfg.tBodyTextoClass.size;
    //     }
    //
    //     return null;
    //   },
    //   set(v) {
    //     let cfg = this.getDivisaoEmEdicaoConfigs();
    //     cfg.tBodyTextoClass.size = v;
    //     this.$store.commit('setDivisaoConfigs', cfg);
    //   }
    // },

    tBodyTextoClassEstilo: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.tBodyTextoClass.estilo;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.tBodyTextoClass.estilo = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    tBodyTextoClassWeight: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.tBodyTextoClass.weight;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.tBodyTextoClass.weight = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    tBodyTextoClassItalic: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.tBodyTextoClass.italic;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.tBodyTextoClass.italic = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    tBodyStyleFontFamily: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.tBodyStyle.fontFamily;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.tBodyStyle.fontFamily = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    tBodyStyleColor: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.tBodyStyle.color;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.tBodyStyle.color = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    tBodyStyleBackgroundColor: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.tBodyStyle["background-color"];
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.tBodyStyle["background-color"] = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    tBodyStyleFontSize: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.tBodyStyle.fontSize;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.tBodyStyle.fontSize = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },
    //tbody

    destaqueExibir: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.destaqueExibir;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.destaqueExibir = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    destaqueTexto: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.destaqueTexto;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.destaqueTexto = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    destaqueIcone: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.destaqueIcone;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.destaqueIcone = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    destaqueIconePosition: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.destaqueIconePosition;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.destaqueIconePosition = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    destaqueRounded: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.destaqueRounded;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.destaqueRounded = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    destaqueOutlined: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.destaqueOutlined;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.destaqueOutlined = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    destaqueStyleColor: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.destaqueStyle.color;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.destaqueStyle.color = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    destaqueStyleBackgroundColor: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.destaqueStyle["background-color"];
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.destaqueStyle["background-color"] = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },
    //<!--endregion tabela-->

    // region cartaz
    // cabecalho
    cabecalhoTexto: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.cabecalhoTexto;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.cabecalhoTexto = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    cabecalhoTextoClassAlign: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.cabecalhoTextoClass.align;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.cabecalhoTextoClass.align = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    cabecalhoTextoClassEstilo: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.cabecalhoTextoClass.estilo;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.cabecalhoTextoClass.estilo = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    cabecalhoTextoClassWeight: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.cabecalhoTextoClass.weight;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.cabecalhoTextoClass.weight = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    cabecalhoTextoClassItalic: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.cabecalhoTextoClass.italic;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.cabecalhoTextoClass.italic = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    cabecalhoStyleFontFamily: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.cabecalhoStyle.fontFamily;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.cabecalhoStyle.fontFamily = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    cabecalhoStyleColor: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.cabecalhoStyle.color;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.cabecalhoStyle.color = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    cabecalhoImg: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.cabecalhoImg;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.cabecalhoImg = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    cabecalhoStyleBackgroundColor: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.cabecalhoStyle["background-color"];
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.cabecalhoStyle["background-color"] = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    cabecalhoStyleFontSize: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.cabecalhoStyle.fontSize;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.cabecalhoStyle.fontSize = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    //MEIO
    meioImg: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.meioImg;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.meioImg = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    meioStyleBackgroundColor: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.meioStyle["background-color"];
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.meioStyle["background-color"] = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    // meioElementos: {
    //     get() {
    //         let cfg = this.getDivisaoEmEdicaoConfigs();
    //
    //         if (cfg) {
    //             return cfg.meioElementos;
    //         }
    //
    //         return null;
    //     },
    //     set(v) {
    //         let cfg = this.getDivisaoEmEdicaoConfigs();
    //         cfg.meioElementos = v;
    //         this.$store.commit('setDivisaoConfigs', cfg);
    //     }
    // },

    //rodapé
    rodapeTexto: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.rodapeTexto;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.rodapeTexto = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    rodapeTextoClassSize: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.rodapeTextoClass.size;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.rodapeTextoClass.size = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    rodapeTextoClassAlign: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.rodapeTextoClass.align;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.rodapeTextoClass.align = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    rodapeTextoClassEstilo: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.rodapeTextoClass.estilo;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.rodapeTextoClass.estilo = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    rodapeTextoClassWeight: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.rodapeTextoClass.weight;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.rodapeTextoClass.weight = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    rodapeTextoClassItalic: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.rodapeTextoClass.italic;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.rodapeTextoClass.italic = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    rodapeStyleFontFamily: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.rodapeStyle.fontFamily;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.rodapeStyle.fontFamily = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    rodapeStyleColor: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.rodapeStyle.color;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.rodapeStyle.color = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    rodapeImg: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.rodapeImg;
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.rodapeImg = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },

    rodapeStyleBackgroundColor: {
      get() {
        let cfg = this.getDivisaoEmEdicaoConfigs();

        if (cfg) {
          return cfg.rodapeStyle["background-color"];
        }

        return null;
      },
      set(v) {
        let cfg = this.getDivisaoEmEdicaoConfigs();
        cfg.rodapeStyle["background-color"] = v;
        this.$store.commit('setDivisaoConfigs', cfg);
      }
    },
    //<!--endregion cartaz-->
  },

  methods: {
    addCartazMeioElementoMercadoria(obj) {
      let el = {
        tipo: "mercadoria",
        conteudo: obj.item.id,
        mercDataAux: obj.item
      };

      this.$store.dispatch('addCartazMeioElemento', el);
    },

    getElementoMercadoria(id) {
      return axios.get('/mercadorias/' + id, {params: []}).then((response) => {
        this.loading = false;
        response.data.codigo + " - " + response.data.descricao;
      }, (error) => {
        console.log(error);
      }).catch(error => {
        console.log(error);
      }).finally(() => this.loading = false);
    },

    addCartazMeioElementoTabelaPreco(obj) {
      let el = {
        tipo: "tabela-preco",
        conteudo: obj.item.id,
        tabelaPrecoDataAux: obj.item
      };

      this.$store.dispatch('addCartazMeioElemento', el);
    },

    addCartazMeioElementoTexto(el) {
      this.$store.dispatch('addCartazMeioElemento', el);
    },

    addCartazMeioElementoImagem(oImg) {
      let el = {
        tipo: "imagem",
        conteudo: oImg.nome_unico,
        nomeOriginal: oImg.nome_original,
      };

      this.$store.dispatch('addCartazMeioElemento', el);
    },
  }
}
</script>
